// extracted by mini-css-extract-plugin
export default {"py":"AcceptCookie_py__CccA4","mainCont":"AcceptCookie_mainCont__UByBu","cont":"AcceptCookie_cont__XZGEG","btn":"AcceptCookie_btn__aTk2p"};